import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';

// Layout & Route Wrappers
import GameShell from './components/Layout/GameShell';
import PremiumRoute from './components/Routing/PremiumRoute';
import ClassroomRoutes from './utils/Routes/classroomRoutes';
import ProtectedRoutes from './utils/Routes/protectedRoutes';
import PublicRoutes from './utils/Routes/publicRoutes';

// Pages
import Access from './pages/Access/Access';
import Cancel from './pages/Cancel/Cancel';
import ClassroomClassic from './pages/Classroom/Classic/Classic';
import Classroom from './pages/Classroom/Classroom';
import ClassroomSandbox from './pages/Classroom/Sandbox/Sandbox';
import ClassroomScales from './pages/Classroom/Scales/Scales';
import Cosmetics from './pages/Cosmetics/Cosmetics';
import Flashcards from './pages/Flashcards/Flashcards';
import ForgotPassword from './pages/ForgotPassword/ForgotPassword';
import Home from './pages/Home/Home';
import Licensing from './pages/Licensing/Licensing';
import Login from './pages/Login/Login';
import NoPage from './pages/NoPage/NoPage';
import Privacy from './pages/Privacy/Privacy';
import Leaderboard from './pages/Leaderboard/Leaderboard';
import Profile from './pages/Profile/Profile';
import Scales from './pages/Scales/Scales';
import Achievements from './pages/Achievements/Achivements';
import Signup from './pages/Signup/Signup';
import Success from './pages/Success/Success';
import Upgrades from './pages/Upgrades/Upgrades';

const App = () => {
  return (
    <Router>
      <div className="container">
        <Routes>
          {/* Open to everyone, signed in or not */}
          <Route path="/licensing" element={<Licensing />} />
          <Route path="/about" element={<Home />} />
          <Route path="/privacy" element={<Privacy />} />

          {/* Guests only: signed-in players get sent to the game */}
          <Route element={<PublicRoutes />}>
            <Route path="/signup" element={<Signup />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/access" element={<Access />} />
          </Route>

          {/* Game shell: sidebar + header around every page below */}
          <Route element={<GameShell />}>
            {/* Open to guests */}
            <Route path="/" element={<Flashcards />} />
            <Route path="/flashcards" element={<Navigate to="/" replace />} />
            <Route path="/scales" element={<Scales />} />
            <Route path="/upgrades" element={<Upgrades />} />
            <Route path="/leaderboard" element={<Leaderboard />} />
            <Route path="/achievements" element={<Achievements />} />

            {/* Needs an account */}
            <Route element={<ProtectedRoutes />}>
              <Route path="/cosmetics" element={<PremiumRoute reason="Cosmetics are a Premium feature."><Cosmetics /></PremiumRoute>} />
              <Route path="/profile" element={<Profile />} />
            </Route>
          </Route>

          {/* Needs an account, no shell */}
          <Route element={<ProtectedRoutes />}>
            <Route path="/success" element={<Success />} />
            <Route path="/cancel" element={<Cancel />} />
          </Route>

          {/* Classroom Routes */}
          <Route element={<ClassroomRoutes />}>
            <Route path="/classroom" element={<Classroom />} />
            <Route path="/classroom/classic" element={<ClassroomClassic />} />
            <Route path="/classroom/sandbox" element={<ClassroomSandbox />} />
            <Route path="/classroom/scales" element={<ClassroomScales />} />
          </Route>

          {/* Anything else */}
          <Route path="*" element={<NoPage />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;